export const statusColors: Record<string, string> = {
    VENCEDOR: '#2ACD72',
    PERDEDOR: '#CD2A2A',
    PENDENTE: '#FF9800',
    'PEDIDO GERADO': '#17A2B8',
    'NÃO OFERTADO': '#101010',
    'SEM PEDIDO': '#101010',
    'NÃO DIGITADO': '#9555FF',
    DIGITADO: '#1A73E8',
}
